import { useQuery } from "@tanstack/react-query";
import { fetchClient } from "../generated/client";

export interface DebugLogDto {
  id: string;
  returnRequestId: string;
  shopId: string;
  source: string;
  operation: string;
  operationType: string;
  status: string;
  resourceId?: string | null;
  resourceType?: string | null;
  error?: string | null;
  duration?: number | null;
  request?: unknown;
  response?: unknown;
  createdAt: number;
}

type UseGetDebugLogsParams = {
  shopId: string;
  returnRequestId: string;
  enabled?: boolean;
};

export function useGetDebugLogs({
  shopId,
  returnRequestId,
  enabled = true,
}: UseGetDebugLogsParams) {
  return useQuery<DebugLogDto[]>({
    queryKey: [
      "get",
      "debug-logs",
      { shopId, returnRequestId },
    ],
    queryFn: async () => {
      const response = await fetchClient.GET(
        // @ts-expect-error endpoint not yet in generated types — run pnpm codegen after backend is up
        "/shops/{shopId}/return-requests/{returnRequestId}/debug-logs",
        {
          params: {
            path: { shopId, returnRequestId },
          },
        },
      );
      return (response.data ?? []) as DebugLogDto[];
    },
    enabled,
  });
}
